// DEPOSIT STEPS
export const DEPOSIT_METHOD_STEP = 0;
export const DEPOSIT_CURRENCY_STEP = 1;
export const DEPOSIT_FIAT_OPERATIONS_STEP = 2;
// CASH
export const DEPOSIT_CASH_STEP = 3;
// BANK WIRE
export const DEPOSIT_WIRE_STEP = 3;
export const DEPOSIT_WIRE_BANK_OPTIONS_STEP = 3;
export const DEPOSIT_WIRE_BANK_REQUISITES_STEP = 4;
// CARD
export const DEPOSIT_CARD_STEP = 3;
export const DEPOSIT_CARD_AMOUNT_STEP = 3;
export const DEPOSIT_CARD_OPTIONS_STEP = 4;
// CRYPTO
export const DEPOSIT_CRYPTO_ASSET_STEP = 1;
export const DEPOSIT_CRYPTO_NETWORK_STEP = 2;
export const DEPOSIT_CRYPTO_ADDRESS_STEP = 3;

// WITHDRAW STEPS
export const WITHDRAW_METHOD_STEP = 0;
export const WITHDRAW_CURRENCY_STEP = 1;
export const WITHDRAW_FIAT_OPERATIONS_STEP = 2;
// CASH
export const WITHDRAW_CASH_STEP = 3;
// WIRE
export const WITHDRAW_WIRE_STEP = 3;
export const WITHDRAW_WIRE_BANK_OPTIONS_STEP = 4;
export const WITHDRAW_WIRE_IBAN_STEP = 5;
export const WIthDRAW_WIRE_AMOUNT_STEP = 6;
export const WITHDRAW_WIRE_DETAILS_STEP = 7;

// CARD
export const WIHTDRAW_CARD_STEP = 3;
export const WITHDRAW_CARD_AMOUNT = 3;
export const WITHDRAW_CARD_OPTIONS = 4;
export const WITHDRAW_CARD_DETAILS = 5;

// CRYPTO
export const WITHDRAW_CRYPTO_ASSET_STEP = 1;
export const WITHDRAW_CRYPTO_NETWORK_STEP = 2;
export const WITHDRAW_CRYPTO_ADDRESS_STEP = 3;
export const WITHDRAW_CRYPTO_AMOUNT_STEP = 4;
export const WITHDRAW_CRYPTO_DETAILS_STEP = 5;

// BUY CRPYTO

export const BUY_CRYPTO_ASSET_SELECT_STEP = 0;
export const BUY_CRYPTO_METHOD_SELECT_STEP = 1;
export const BUY_CRYPTO_SELECTED_METHOD_STEP = 2;

// BUY CRYPTO -> CARD
export const BUY_CRYPTO_CARD_AMOUNT_STEP = 2;
export const BUY_CRYPTO_CARD_SELECT_STEP = 3;
export const BUY_CRYPTO_CARD_DETAILS = 4;

// BUY CRYPTO -> BALANCE

export const BUY_CRYPTO_BALANCE_PREFERRED_ASSET_STEP = 2;
export const BUY_CRYPTO_BALANCE_AMOUNT_STEP = 3;
export const BUY_CRYPTO_BALANCE_DETAILS = 4;

// BUY CRYPTO -> BANK WIRE

export const BUY_CRYPTO_WIRE_BANK_CURRENCY_SELECT_STEP = 2;
export const BUY_CRYPTO_WIRE_BANK_OPTION_SELECT_STEP = 3;
export const BUY_CRYPTO_WIRE_BANK_REQUISITES_STEP = 4;

// SELL CRYPTO

export const SELL_CRYPTO_ASSET_SELECT_STEP = 0;
export const SELL_CRYPTO_AMOUNT_STEP = 1;
export const SELL_CRYPTO_DETAILS_STEP = 2;
